// Admin — lista articoli (italiano).
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/modules/growing-circle/lib/api";
import { Button } from "@/components/ui/button";
import { FilePlus } from "lucide-react";

const STATE_LABEL = {
  draft: "Bozza", scheduled: "Programmato", published: "Pubblicato",
  unpublished: "Non pubblicato", archived: "Archiviato",
};

function fmt(iso) { try { return new Date(iso).toLocaleString("it-IT"); } catch { return iso || ""; } }

export default function AdminArticles() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/articles").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);
  if (items === null) return <p className="text-muted-foreground text-sm">Caricamento…</p>;
  return (
    <div data-testid="admin-articles">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-heading text-3xl tracking-tight">Articoli</h1>
        <Link to="/growing-circle/admin/articles/new">
          <Button className="btn-gold rounded-full h-10 px-5 text-xs uppercase tracking-[0.14em]" data-testid="new-article-btn">
            <FilePlus className="w-4 h-4 mr-2" />Nuovo articolo
          </Button>
        </Link>
      </div>
      <div className="bg-card border border-border rounded-2xl overflow-x-auto">
        <table className="min-w-full text-sm" data-testid="admin-articles-table">
          <thead className="text-xs uppercase tracking-[0.12em] text-muted-foreground">
            <tr><th className="text-left px-4 py-3">Titolo</th><th className="text-left px-4 py-3">Stato</th><th className="text-left px-4 py-3">Aggiornato</th><th></th></tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} className="border-t border-border" data-testid={`article-row-${a.id}`}>
                <td className="px-4 py-3">
                  <div className="font-medium">{a.fields?.title || "(senza titolo)"}</div>
                  <div className="text-xs text-muted-foreground">/{a.slug}</div>
                </td>
                <td className="px-4 py-3"><span className="text-xs uppercase tracking-[0.12em]">{STATE_LABEL[a.state] || a.state}</span></td>
                <td className="px-4 py-3 text-muted-foreground text-xs">{fmt(a.updated_at)}</td>
                <td className="px-4 py-3 text-right">
                  <Link to={`/growing-circle/admin/articles/${a.id}/edit`} className="text-primary hover:underline text-xs uppercase tracking-[0.12em]" data-testid={`edit-${a.id}`}>Modifica</Link>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={4} className="px-4 py-8 text-center text-muted-foreground">Nessun articolo. Clicca "Nuovo articolo" per iniziare.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
